/* api接口地址汇总
 * @Author: nowThen
 * @Date: 2019-08-14 16:05:21
 */

export const apiUrl = {
  login: '/api/login',
  loginOut: '/api/loginOut',

  // mock
  qryPageConfig: '/test/pageConfig',

  msg: '/index/securityPolicy'
}
